import type { Application, ApplicationStage } from '../types/application';

/** Funnel stages before package selection; USCIS fee is not valid here. */
const STAGES_BEFORE_PACKAGE: ApplicationStage[] = [
  'eligibility_check',
  'eligibility_completed',
  'qualified',
  'disqualified',
];

/**
 * Whether the user may open the /application/:id/uscis-fee route or call USCIS fee APIs.
 */
export function canAccessUscisFeeFlow(app: Application): boolean {
  if (STAGES_BEFORE_PACKAGE.includes(app.stage)) return false;
  return true;
}
